// translation.js
const translation = {

    // GERAL PORTUGUES
    pageTitulo: "Analytical Hierarchy Process Decision Tool",
    buttonAdicionar:"Adicionar",
    switchLanguage: "Mudar para inglês",
    ptSwitchLanguage: "PT",
    enSwitchLanguage: "EN",
    selectMethod: "SELECIONE O MÉTODO",
    sim: "Sim",
    nao: "Não",
    selecione: "Selecione",
    baixo: "Baixo",
    medio: "Médio",
    alto: "Alto",
    tituloFluxograma: "FLUXOGRAMA",
    tituloInputs: "PARÂMETROS DE ESCOLHA",
    tituloIlustration: "ILUSTRAÇÃO",
    exportProject: "Exportar Projeto",
    importProject: "Importar Projeto",
    resetProject: "Resetar Projeto",
    continueProject: "Continue Project",
    step: "ETAPA",
    resultados: "RESULTADOS",

    // FOOTER PORTUGUES
    universidadeFooter: "Universidade Federal do Rio Grande do Sul",
    laboratorioFooter: "Laboratório de Processamento Mineral",
    localizacaoUmFooter: "Avenida Bento Gonçalves, 9500, Campus do Vale, Setor 6, Centro de Tecnologia, LAPROM",
    localizacaoDoisFooter: "Porto Alegre, Rio Grande do Sul, Brasil. CEP: 91501-970",
    contatoFooter: "Contato: email@ufrgs.com",
    linksFooter: "Links",
    creditosFooter: "Creditos",
    referenciasFooter: "Referências",
    reportarErroFooter: "Reportar Erro",

    // POPUP CREDITOS PORTUGUES
    creditosTituloPopUp: "CREDITOS",
    universidadeCreditos: "UNIVERSIDADE FEDERAL DO RIO GRANDE DO SUL",
    laboratorioCreditos: "LABORATÓRIO DE PROCESSAMENTO MINERAL",
    versaoCreditos: "VERSÃO 1.0",
    tituloFerramentaCreditos: "Analytical Hierarchy Process",
    tituloAutoresCreditos: "AUTORES",
    nomeAutoresCreditos: "HIGOR CAMPOS",
    tituloApoioCreditos: "APOIO",
    apoioUmCreditos: "EQUIPE MAFMINE",
    localizacaoCreditos: "Porto Alegre, Rio Grande do Sul, Brasil",
    dataCreditos: "2023",

    // POPUP REFERENCIAS PORTUGUES
    referenciasTituloPopUp: "REFERENCIAS",
    maisSobreAhpTituloPopUp: "REFERENCIAS AHP",
    tituloReferencias: "REFERENCIAS",
    referenciaCardozoArtigo: "CARDOZO, F. A. C. et al. Choice of access for underground mining for feasibility studies. REM-International Engineering Journal, v. 76, p. 187-193, 2023.",
    referenciaCardozoTese: "CARDOZO, F. A. C. Modelagem de Escavações Subterrâneas: Contribuições para Escolha de Acessos de Mina. Doutorado—Porto Alegre: Universidade Federal do Rio Grande do Sul, 3 mar. 2023.",
    referenciaAtaei: "ATAEI, M. et al. Mining Method Selection By AHP Approach. Journal of the Southern African Institute of Mining and Metallurgy, v. 108, n. 12, p. 741–749, 2008.",
    referenciaShariar: "SHAHRIAR, K. et al. A New Numerical Method And AHP For Mining Method Selection. Proc. 4th Int. Symp, on ‘High performance mine production. p. 289–306. 2007.",
    referenciaBanda: "BANDA, W. An integrated framework comprising of AHP, expert questionnaire survey and sensitivity analysis for risk assessment in mining projects. International Journal of Management Science and Engineering Management, v. 14, n. 3, p. 180-192, 2019.",
    referenciaSaaty: "SAATY, T. L. How to make a decision: the analytic hierarchy process. European journal of operational research, 48(1), 9-26. 1996",
    referenciaRibeiro: "RIBEIRO, M. C. D. C. R., & da Silva Alves, A. Aplicação do método Analytic Hierarchy Process (AHP) com a mensuração absoluta num problema de seleção qualitativa. Sistemas & Gestão, 11(3), 270-281. 2016. ",

    // POP UP REPORTAR ERRO
    reportarErroTituloPopUp: "REPORTAR ERRO",
    userNameReportarErro: "Seu nome:",
    userEmailReportarErro: "Seu e-mail:",
    userMessageReportarErro: "Sua mensagem:",
    botaoEnviarReportarErro: "ENVIAR",

    // INPUTS MCDM PORTUGUES
    tituloMcdm: "SELEÇÃO DE ACESSOS PARA MINAS SUBTERRÂNEAS: Análise Multicriterial",
    mcdmTituloCriterios: "CRITÉRIOS",
    mcdmTituloOptions: "OPÇÕES",
    inputNomeLabelCriterios: "Informe e nomeie os critérios de seleção abaixo",
    inputNomeLabelOptions: "Informe e nomeie as opções para comparação abaixo ",
    inputSimboloLabel: "Simbolo",

    // PRIMEIRA ETAPA
    tituloMatrizSegundaEtapaAhp: "Comparação de Critérios",

    // RESULTADOS ETAPA
    matrizPrioridadesGlobais: "MATRIZ DE PRIORIDADES LOCAIS",
    vetorPrioridadeGlobal: "VETOR DE PRIORIDADES GLOBAIS",
    tituloPesoGlobal: "Peso do critério",

    // MENU LATERAL DIREITO AHP
    helpEscalaSaaty: "ESCALA AHP",
    helpMaisSobreAhp:"MAIS SOBRE AHP",
    helpPrimeiraEtapa:"HELP ETAPA 1",
    helpSegundaEtapa:"HELP ETAPA 2",
    helpResultadosEtapa:"HELP RESULTADOS",

    // POP UP MAIS SOBRE AHP
    tituloMaisSobreAhp:"MAIS SOBRE AHP",

    // POP UP TABELA SAATY ESCALA AHP PORTUGUES
    tituloEscalaSaaty: "ESCALA DE COMPARAÇÃO",
    verbalEscalaSaaty: "Verbal",
    numericaEscalaSaaty: "Númerica",
    igualImportanciaEscalaSaaty: "Igual importância",
    moderadamenteSuperiorEscalaSaaty: "Moderadamente superior",
    superiorEscalaSaaty: "Superior",
    muitoSuperiorEscalaSaaty: "Muito Superior",
    extremamenteSuperiorEscalaSaaty: "Extremamente superior",
    legendaEscalaSaaty: "Os valores 2,4,6 e 8 são intermediários.",

    // POP UP PASSOS AHP
    helpCalculosAhp:"PASSO A PASSO",
    passosAhpTituloPopUp:"PASSO A PASSO AHP",
    tituloAhpPassos: "PASSO A PASSO AHP",
    ahpPassoUm:"1º - CRIAÇÃO DA MATRIZ DE COMPARAÇÃO DE PARES",
    ahpPassoUmUm:"Utilizar a escala de comparação de pares AHP",
    ahpPassoUmDois:"Julgar cada item das linhas da matriz em relação ao item da coluna",
    ahpPassoDois:"2º - SOMATÓRIO DAS COLUNAS DA MATRIZ DE JULGAMENTO",
    ahpPassoDoisUm:"Somar cada coluna individualmente (um valor de soma para cada critério).",
    ahpPassoTres:"3º - NORMATIZAR A MATRIZ DE JULGAMENTO",
    ahpPassoTresUm:"Dividir cada item das colunas da matriz pela soma de sua própria coluna",
    ahpPassoQuatro:"4º - CALCULAR O VETOR DOS PESOS DE CADA CRITÉRIO (W)",
    ahpPassoQuatroUm:"O peso de cadacritério é igual a média aritmética da linha, correspondente ao critério, na matriz normalizada.",
    ahpPassoCinco:"5º - CALCULAR O VETOR SOMA PONDERADA (WS)",
    ahpPassoCincoUm:"O vetor WS é o resultado da multiplicação da matriz de julgamento inicial pelo vetor dos pesos dos critérios",
    ahpPassoSeis:"6º - CALCULAR O VETOR CONSISTENCIA",
    ahpPassoSeisUm:"O vetor consistência é resultado da divisão do vetor WS pelo vetor dos pesos dos critérios (W)",
    ahpPassoSete:"7º - CALCULAR O MÁXIMO AUTOVALOR DA MATRIZ DE JULGAMENTO",
    ahpPassoSeteUm:"O máximo autovalor (𝜆max) é igual à média aritmética dos elementos do vetor consistência.",
    ahpPassoOito:"8º - CALCULAR OÍNDICE DE CONSISTENCIA DO JULGAMENTO (CI)",
    ahpPassoOitoUm:"𝐶𝐼 = (𝜆max − 𝑛)/(𝑛 − 1)>, onde n é a ordem da matriz.",
    ahpPassoOitoDois:"Exemplo de inconsistência: A>B, B>C e C>A",
    ahpPassoNove:"9º - OBTER O ÍNDICE DE ALEATÓRIEDADE PARA A MATRIZ DE JULGAMENTO (RI)",
    ahpPassoNoveUm:"O índice de aleatoriedade é um valor tabelado (Saaty, 1991), que representa o índice de consistência médio de matrizes recíprocas, geradas por valores aleatórios.",
    ahpPassoDez:"10º - CALCULAR A RAZÃO DE CONSISTENCIA (CR)",
    ahpPassoDezUm:"O CR índica o quão consistente a matriz de julgamento está em relação a matrizes geradas aleatoriamente.",
    ahpPassoDezDois:"𝐶𝑅 = 𝐶𝐼/𝑅𝐼",
    ahpPassoOnze:"11º - ANÁLISAR OS RESULTADOS",
    ahpPassoOnzeUm:"Se CR < 0.1, a matriz de julgamento foi construída com sucesso e os pesos podem ser utilizados.",
    ahpPassoOnzeDois:"Se CR >= 0.1, a matriz de julgamento está inconsistente e o processo deve ser reiniciado (voltar ao passo 1)",

    // METADADOS
    homePageTitle: "Analytical Hierarchy Process",
    homePageDescription: "Analytical Hierarchy Process",
    homePageKeywords: "Analytical Hierarchy Process"
}

export default translation
